import { cycloneApiClient } from '@/shared/api/core/axios-instance';

import { getDagOverviewMock } from '@/entities/dag/api/_internal/dagMockStore';
import { shouldUseDagMockApi } from '@/entities/dag/api/_internal/shouldUseDagMockApi';
import type { DagOverviewRequest, DagOverviewResponse } from '@/entities/dag/domain/types';

export const fetchDagOverviewApi = async ({ dagUuid }: DagOverviewRequest): Promise<DagOverviewResponse> => {
  const normalizedDagUuid = dagUuid.trim();

  if (!normalizedDagUuid) {
    throw new Error('DAG UUID is required');
  }

  if (shouldUseDagMockApi()) {
    return getDagOverviewMock(normalizedDagUuid);
  }

  const response = await cycloneApiClient.get<DagOverviewResponse>(`/dags/${normalizedDagUuid}/overview`);
  return response.data;
};
